import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "react-router";
import type { LoaderFunctionArgs, HeadersFunction } from "react-router";
import { addDocumentResponseHeaders } from "./shopify.server";

export async function loader({ request }: LoaderFunctionArgs) {
  // addDocumentResponseHeaders MUTATES the Headers it is given and returns
  // void — passing its return value straight through set no headers at all.
  const headers = new Headers();
  addDocumentResponseHeaders(request, headers);
  return new Response(null, { headers });
}

export const headers: HeadersFunction = ({ loaderHeaders }) => loaderHeaders;

export default function App() {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
